import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LocationAwaySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LocationAwaySVG;
